import {
	IonCol,
	IonGrid,
	IonRow,
	IonItem,
	IonCardHeader,
	IonCard,
	IonCardContent,
	IonLabel
} from "@ionic/react";
import Chart from "chart.js/auto";
import { ArcElement } from "chart.js";
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend
} from "chart.js";
import { Doughnut, Line } from "react-chartjs-2";
import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import useStore from "../store/store";

ChartJS.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend
);

export const options = {
	responsive: true,
	plugins: {
		legend: {
			position: "top" as const
		}
	}
};

Chart.register(ArcElement);

const DoughnutChart = (props: any) => {
	const { t } = useTranslation();
	let [vacant, setVacant] = useState(0);
	let [occupied, setOccupied] = useState(0);
	const { token } = useStore(state => state);
	const data = {
		labels: [t("vacant"), t("occupied")],
		datasets: [
			{
				data: [vacant, occupied],
				backgroundColor: ["rgb(54, 162, 235)", "rgb(255, 205, 86)"]
			}
		]
	};

	useEffect(() => {
		axios
			.post(
				`${process.env.REACT_APP_API_URL}/properties/all`,
				{
					keyword: ""
				},
				{ headers: { rentapp_auth: token } }
			)
			.then(res => {
				let vacant = res.data.filter(
					(elem: any) => elem.status === "vacant"
				);
				let occupied = res.data.filter(
					(elem: any) => elem.status === "occupied"
				);
				setVacant(vacant.length);
				setOccupied(occupied.length);
			})
			.catch(err => console.log(err));
	}, []);

	return (
		<>
			<IonCol size="12">
				<IonCard>
					<IonCardHeader>
						<IonLabel style={{ fontSize: 20, fontWeight: "bold" }}>
							{t("occupancy")} {vacant} / {occupied}
						</IonLabel>
					</IonCardHeader>
					<IonCardContent>
						<Doughnut
							options={options}
							data={data}
							style={{ maxHeight: 400, maxWidth: 400 }}
						/>
					</IonCardContent>
				</IonCard>
			</IonCol>
		</>
	);
};

export default DoughnutChart;
